import { TarefaStatus, TarefaStatusMap } from "@workflow/types";
import { ChartConfig } from "@/components/ui/chart";

/** Cores por status usadas no gráfico do painel admin — mesma paleta do TAREFA_STATUS_COLOR_MAP (badges). */
export const TAREFA_STATUS_CHART_CONFIG = {
  [TarefaStatus.PENDENTE]: { label: TarefaStatusMap[TarefaStatus.PENDENTE], color: "#f59e0b" },
  [TarefaStatus.EM_EXECUCAO]: {
    label: TarefaStatusMap[TarefaStatus.EM_EXECUCAO],
    color: "#3b82f6",
  },
  [TarefaStatus.CONCLUIDO]: { label: TarefaStatusMap[TarefaStatus.CONCLUIDO], color: "#10b981" },
  [TarefaStatus.CANCELADO]: { label: TarefaStatusMap[TarefaStatus.CANCELADO], color: "#ef4444" },
  [TarefaStatus.ARQUIVADO]: { label: TarefaStatusMap[TarefaStatus.ARQUIVADO], color: "#6b7280" },
} satisfies ChartConfig;
